import React from "react";
import { numToDay } from "../../utils/time";
import range from "../../utils/range";
import SwipeToToggle from "./";
import Round from "../Buttons/Round/index";

const allDays = range(1, 6).concat([6, 0]);

export default ({ days = [], onChange }) => (
  <SwipeToToggle
    className="text-left"
    handleDragOver={day => onChange(Number(day))}
    selector="day"
  >
    {(allDays || []).map((day, i) => (
      <Round
        key={i}
        day={day}
        fontSize={18}
        className="m-1"
        active={days.includes(day)}
        onClick={() => onChange(day)}
      >
        {numToDay(day)}
      </Round>
    ))}
  </SwipeToToggle>
);



// WEBPACK FOOTER //
// ./src/components/SwipeToggle/days.js